module.exports = __webpack_public_path__ + "img/spa_thumbnail-400x300.329aa57a.jpg";